import Vue from 'vue';
import { API_HOST } from '../constants';

export default {
  claim(params) {
    return Vue.axios.post(`${API_HOST}/parcel-claim`, params);
  },
  claimCancel(id) {
    return Vue.axios.delete(`${API_HOST}/parcel-claim/${id}`);
  },
  getClaims() {
    return Vue.axios.get(`${API_HOST}/parcel-claim`);
  },
  getParcels(params) {
    return Vue.axios.get(`${API_HOST}/parcel`, { params });
  },
  count() {
    return Vue.axios.get(`${API_HOST}/parcel-count`);
  },
  getParcelId(id) {
    return Vue.axios.get(`${API_HOST}/parcel/${id}`);
  },
  postActivePushParcel(params) {
    return Vue.axios.post(`${API_HOST}/active-push-parcel`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/parcel.js